export enum Role {
    ADMIN = 'ATOM_Administrator',
    LINE_SETTER = 'ATOM_Manufacturing_Technician',
    MILKRUN_OPERATOR = 'ATOM_Transport',
    LIFT_OPERATOR = 'ATOM_Storage',
    ATOM_OPERATOR = 'ATOM_Operator',
    SERVICE_OPERATOR = 'ATOM_Service',
}
